import * as sagaEffects from 'redux-saga/effects';

import handleInfoCategoriesRequestSaga from './infoCategories/handleInfoCategoriesRequestSaga';
import handleInfoCategoryDetailRequestSaga from './infoCategories/handleInfoCategoryDetailRequestSaga';
import handleAddInfoCategoryRequestSaga from './infoCategories/handleAddInfoCategoryRequestSaga';
import handleUpdateInfoCategoryRequestSaga from './infoCategories/handleUpdateInfoCategoryRequestSaga';
import handleUpdateInfoCategoryOrderSaga from './infoCategories/handleUpdateInfoCategoryOrderSaga';
import handleDeleteInfoCategoryRequestSaga from './infoCategories/handleDeleteInfoCategoryRequestSaga';

import handleInfoRequestSaga from './info/handleInfoRequestSaga';
import handleInfoDetailRequestSaga from './info/handleInfoDetailRequestSaga';
import handleAddInfoRequestSaga from './info/handleAddInfoRequestSaga';
import handleUpdateInfoRequestSaga from './info/handleUpdateInfoRequestSaga';
import handleUpdateInfoOrderSaga from './info/handleUpdateInfoOrderSaga';
import handleDeleteInfoRequestSaga from './info/handleDeleteInfoRequestSaga';

const { all } = sagaEffects;

export default function* () {
    yield all([
        handleInfoCategoriesRequestSaga(),
        handleInfoCategoryDetailRequestSaga(),
        handleAddInfoCategoryRequestSaga(),
        handleUpdateInfoCategoryRequestSaga(),
        handleUpdateInfoCategoryOrderSaga(),
        handleDeleteInfoCategoryRequestSaga(),
        handleInfoRequestSaga(),
        handleInfoDetailRequestSaga(),
        handleAddInfoRequestSaga(),
        handleUpdateInfoRequestSaga(),
        handleUpdateInfoOrderSaga(),
        handleDeleteInfoRequestSaga(),
    ]);
}
